import { lazy, Suspense } from "react";
import Loading from "../components/loading/Loading";
import PagesConfigs from "../configs/pages.config.json";
import { Routes, Route, Navigate } from "react-router-dom";

/**
 * The component is used to render the pages of the application.
 *
 * @returns {JSX.Element}
 */

const Layout = lazy(() => import("../components/layout/Layout"));
const Dashboard = lazy(() => import("../pages/dashboard/Dashboard"));
const Setting = lazy(() => import("../pages/setting/Setting"));
const SandboxSetting = lazy(() => import("../pages/setting/sandbox-setting"));
const CarParkSetting = lazy(() => import("../pages/setting/carpark-setting"));
const Page404 = lazy(() => import("../pages/page404/Page404"));

const Pages = () => {
    const hasSubRoutesPath = ["/setting"];
    const mappingPathObj = {
        "/": { element: <Dashboard /> },
        "/setting": {
            element: <Setting />,
            children: [
                { path: "sandbox", element: <SandboxSetting /> },
                { path: "carpark", element: <CarParkSetting /> },
            ],
        },
    };
    return (
        <Suspense fallback={<Loading directlyshow={true} />}>
            <Routes>
                <Route path="/" element={<Layout />}>
                    <Route path="*" element={<Page404 />} />
                    {Object.keys(PagesConfigs).map((path) => {
                        if (path === "/") {
                            return (
                                <Route key={path} index element={mappingPathObj[path].element} />
                            );
                        }
                        if (hasSubRoutesPath.includes(path)) {
                            return (
                                <Route
                                    key={path}
                                    path={path}
                                    element={mappingPathObj[path].element}>
                                    {mappingPathObj[path].children.map((child) => {
                                        return (
                                            <Route
                                                key={child.path}
                                                path={child.path}
                                                element={child.element}
                                            />
                                        );
                                    })}
                                    <Route
                                        key={path + "redirect"}
                                        path={path}
                                        element={
                                            <Navigate
                                                to={`${path}/${mappingPathObj[path].children[0].path}`}
                                            />
                                        }
                                    />
                                </Route>
                            );
                        }
                        return (
                            <Route key={path} path={path} element={mappingPathObj[path].element} />
                        );
                    })}
                </Route>
            </Routes>
        </Suspense>
    );
};

export default Pages;
